import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import CustomTable from "../../../../../CustomHeadlessTable/CustomTable";
import {
  getBusinessVehicles,
  addVehicleToBusiness,
  updateVehicle,
  deleteVehicle,
} from "../../../../../../apis/Business/Business";
import CustomInputComponent from "../../../../../CustomHeadlessTable/components/CustomInputComponent";

const NonFuelVehicleTable = ({
  businessId,
  subcategory,
  subcategory_description,
  subcategoryId,
}) => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [isOptional, setIsOptional] = useState(true);

  const [dropdownVehicle, setDropdownVehicle] = useState([
    {
      id: 1,
      name: t("TRUCK"),
      value: t("TRUCK"),
      type: t("TRUCK"),
      typeDB: "truck",
      key: "TRUCK",
    },
    {
      id: 2,
      name: t("PASSENGER_CAR"),
      value: t("PASSENGER_CAR"),
      type: t("PASSENGER_CAR"),
      typeDB: "passenger_car",
      key: "PASSENGER_CAR",
    },
    {
      id: 3,
      name: t("MOTORBIKE"),
      value: t("MOTORBIKE"),
      type: t("MOTORBIKE"),
      typeDB: "motorbike",
      key: "MOTORBIKE",
    },
    {
      id: 4,
      name: t("BUS"),
      value: t("BUS"),
      type: t("BUS"),
      typeDB: "bus",
      key: "BUS",
    },
    {
      id: 4,
      name: t("VAN"),
      value: t("VAN"),
      type: t("VAN"),
      typeDB: "van",
      key: "VAN",
    },
    {
      id: 4,
      name: t("PLANE"),
      value: t("PLANE"),
      type: t("PLANE"),
      typeDB: "plane",
      key: "PLANE",
    },
    {
      id: 4,
      name: t("SHIP"),
      value: t("SHIP"),
      type: t("SHIP"),
      typeDB: "ship",
      key: "SHIP",
    },
  ]);

  const [dropdownFuel, setDropdownFuel] = useState([
    {
      id: 1,
      name: t("DIESEL"),
      value: t("DIESEL"),
      type: t("DIESEL"),
      typeDB: "diesel",
      key: "DIESEL",
    },
    {
      id: 2,
      name: t("LNG_L"),
      value: t("LNG_L"),
      type: t("LNG_L"),
      typeDB: "LNG_L",
      key: "LNG_L",
    },
    {
      id: 3,
      name: t("GASOLINE"),
      value: t("GASOLINE"),
      type: t("GASOLINE"),
      typeDB: "gasoline",
      key: "GASOLINE",
    },
    {
      id: 4,
      name: t("CNG"),
      value: t("CNG"),
      type: t("CNG"),
      typeDB: "CNG",
      key: "CNG",
    },
    {
      id: 4,
      name: t("EL"),
      value: t("EL"),
      type: t("EL"),
      typeDB: "EL",
      key: "EL",
    },
    {
      id: 4,
      name: t("HYBRID"),
      value: t("HYBRID"),
      type: t("HYBRID"),
      typeDB: "hybrid",
      key: "HYBRID",
    },
  ]);

  const toggleColumnVisibility = useCallback((columnId) => {
    setHiddenColumns((prev) =>
      prev.includes(columnId)
        ? prev.filter((id) => id !== columnId)
        : [...prev, columnId]
    );
  }, []);

  useEffect(() => {
    setDropdownVehicle([
      {
        id: 1,
        name: t("TRUCK"),
        value: t("TRUCK"),
        type: t("TRUCK"),
        typeDB: "truck",
        key: "TRUCK",
      },
      {
        id: 2,
        name: t("PASSENGER_CAR"),
        value: t("PASSENGER_CAR"),
        type: t("PASSENGER_CAR"),
        typeDB: "passenger_car",
        key: "PASSENGER_CAR",
      },
      {
        id: 3,
        name: t("MOTORBIKE"),
        value: t("MOTORBIKE"),
        type: t("MOTORBIKE"),
        typeDB: "motorbike",
        key: "MOTORBIKE",
      },
      {
        id: 4,
        name: t("BUS"),
        value: t("BUS"),
        type: t("BUS"),
        typeDB: "bus",
        key: "BUS",
      },
      {
        id: 4,
        name: t("VAN"),
        value: t("VAN"),
        type: t("VAN"),
        typeDB: "van",
        key: "VAN",
      },
      {
        id: 4,
        name: t("PLANE"),
        value: t("PLANE"),
        type: t("PLANE"),
        typeDB: "plane",
        key: "PLANE",
      },
      {
        id: 4,
        name: t("SHIP"),
        value: t("SHIP"),
        type: t("SHIP"),
        typeDB: "ship",
        key: "SHIP",
      },
    ]);

    setDropdownFuel([
      {
        id: 1,
        name: t("DIESEL"),
        value: t("DIESEL"),
        type: t("DIESEL"),
        typeDB: "diesel",
        key: "DIESEL",
      },
      {
        id: 2,
        name: t("LNG_L"),
        value: t("LNG_L"),
        type: t("LNG_L"),
        typeDB: "LNG_L",
        key: "LNG_L",
      },
      {
        id: 3,
        name: t("GASOLINE"),
        value: t("GASOLINE"),
        type: t("GASOLINE"),
        typeDB: "gasoline",
        key: "GASOLINE",
      },
      {
        id: 4,
        name: t("CNG"),
        value: t("CNG"),
        type: t("CNG"),
        typeDB: "CNG",
        key: "CNG",
      },
      {
        id: 4,
        name: t("EL"),
        value: t("EL"),
        type: t("EL"),
        typeDB: "EL",
        key: "EL",
      },
      {
        id: 4,
        name: t("HYBRID"),
        value: t("HYBRID"),
        type: t("HYBRID"),
        typeDB: "hybrid",
        key: "HYBRID",
      },
    ]);
  }, [t]);

  const fetchData = useCallback(() => {
    getBusinessVehicles({
      id: businessId,
      setVehicles: setData,
      subcategory: subcategory,
      subcategory_description: subcategory_description,
      subcategoryId: subcategoryId,
    });
  }, [businessId, subcategory, subcategoryId, subcategory_description]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleEdit = useCallback(
    (editedItem) => {
      updateVehicle({
        businessId,
        vehicleId: editedItem.id,
        ...editedItem,
        subcategory: subcategory,
        subcategory_description: subcategory_description,
        vehicle_type: editedItem["vehicle_type.value"]
          ? editedItem["vehicle_type.value"].value
          : editedItem["vehicle_type"]
          ? editedItem["vehicle_type"].value
          : null,
        fuel_type: editedItem["fuel_type.value"]
          ? editedItem["fuel_type.value"].value
          : editedItem["fuel_type"]
          ? editedItem["fuel_type"].value
          : null,
        subcategoryId: subcategoryId,
        objects: data,
        setObjects: setData,
        use_swal: true,
      });
    },
    [
      businessId,
      data,
      setData,
      subcategory,
      subcategory_description,
      subcategoryId,
    ]
  );

  const handleAdd = useCallback(
    (newItem) => {
      addVehicleToBusiness({
        businessId,
        ...newItem,
        vehicle_type: newItem["vehicle_type.value"]
          ? newItem["vehicle_type.value"].value
          : null,
        fuel_type: newItem["fuel_type.value"]
          ? newItem["fuel_type.value"].value
          : null,
        subcategory: subcategory,
        subcategory_description: subcategory_description,
        subcategoryId: subcategoryId,
        callback: fetchData,
        use_swal: true,
      });
    },
    [businessId, fetchData, subcategory, subcategory_description, subcategoryId]
  );

  const handleDelete = useCallback(
    (itemToDelete) => {
      deleteVehicle({
        businessId,
        vehicleId: itemToDelete.id,
        callback: fetchData,
      });
    },
    [businessId, fetchData]
  );

  const dynamicPlaceholders = useMemo(
    () => ({
      manuel: {
        targetField: "fuel_type.value",
        getPlaceholder: (selectedValue, dropdownData) => {
          if (selectedValue) {
            setIsOptional(false);
          } else if (selectedValue === null || selectedValue === undefined) {
            setIsOptional(true);
          }
        },
      },
    }),
    []
  );

  const columns = useMemo(
    () => [
      {
        accessor: "invoice_date",
        header: t("INVOICE_DATE"),
        type: "text",
        canHide: true,
        canSort: true,
        placeholder: t("DD_MM_YYYY"),
        optional: true,
        width: "80px",
      },
      {
        accessor: "invoice_number",
        header: t("INVOICE_NO"),
        type: "text",
        canSort: true,
        canHide: true,
        optional: true,
        width: "80px",
      },
      {
        accessor: "vehicle_registration",
        header: t("CAR_REGISTRATION"),
        type: "text",
        width: "140px",
        placeholder: t("Car Registration"),
      },
      {
        accessor: "vehicle_type.value",
        header: `${t("TYPE_VEHICLE")}*`,
        type: "dropdown",
        dropdownData: dropdownVehicle,
        disableSortBy: true,
        tipHeader: "Tip",
        tipBody: t("TYPE_VEHICLE_TIP"),
        width: "110px",
      },
      {
        accessor: "distance",
        header: `${t("DRIVEN_DISTANCE")} (km)`,
        type: "number",
        tipHeader: "Tip",
        tipBody: t("DRIVEN_DISTANCE_TIP"),
        disableSortBy: true,
        placeholder: t("DISTANCE"),
        width: "90px",
        optional: true,
      },
      {
        accessor: "leased",
        header: t("IS_VEHICLE_LEASED"),
        type: "switch",
        disableSortBy: true,
        width: "90px",
      },
      {
        accessor: "life_expectancy",
        header: `${t("LIFE_EXPECTANCY")} (${t("YEAR")})`,
        type: "number",
        disableSortBy: true,
        placeholder: t("LIFE_EXPECTANCY"),
        width: "90px",
      },
      {
        accessor: "fuel_type.value",
        header: t("FUEL_TYPE"),
        type: "dropdown",
        dropdownData: dropdownFuel,
        disableSortBy: true,
        width: "110px",
        optional: isOptional,
      },
      {
        accessor: "fuel_amount",
        header: t("QTY_PURCHASED_FUEL"),
        type: "number",
        disableSortBy: true,
        placeholder: t("REGISTERED_AMOUNT"),
        width: "80px",
        optional: true,
        tipHeader: "Tip",
        tipBody: t("QTY_PURCHASED_FUEL_TIP"),
      },
      {
        accessor: "battery_charging",
        header: t("VEHICLE_CHARGE?"),
        type: "switch",
        choice1: "No",
        choice2: "Yes",
        disableSortBy: true,
        width: "90px",
        tipHeader: "Tip",
        tipBody: t("BATTERY_CHARGING_TIP"),
      },
      {
        accessor: "manuel",
        header: "Manual gCO₂/km",
        type: "number",
        disableSortBy: true,
        placeholder: "0",
        width: "90px",
        optional: true,
        tipHeader: "Tip",
        tipBody: t("TIP_MANUEL_VEH"),
      },
      {
        accessor: "spacer1",
        header: "",
        type: "spacer",
        width: "20px",
        optional: true,
        disableSortBy: true,
      },
      {
        accessor: "price_invoice",
        header: t("PRICE_INVOICE"),
        type: "number",
        canSort: true,
        canHide: true,
        placeholder: "0",
        optional: true,
        subtotalUnit: "DKK",
        width: "80px",
        tipHeader: "Tip",
        tipBody: t("PRICE_INVOICE_TIP"),
      },
      {
        accessor: "carbon",
        header: t("CARBON_OUTPUT"),
        type: "custom",
        canSort: true,
        cell: ({ value }) => {
          return <CustomInputComponent value={value} readOnly />;
        },
        optional: true,
        subtotalUnit: "tCO₂e",
        subtotalFixed: true,
        width: "80px",
      },
    ],
    [dropdownFuel, dropdownVehicle, t, isOptional]
  );

  const disableRules = {
    carbon: () => true,
  };

  const subtotalColumns = {
    price_invoice: { label: t("TOTAL_PRICE") },
    carbon: { label: t("TOTAL_CARBON") },
  };

  const memoizedDropdownData = useMemo(
    () => ({
      "vehicle_type.value": dropdownVehicle,
      "fuel_type.value": dropdownFuel,
    }),
    [dropdownVehicle, dropdownFuel]
  );

  return (
    <CustomTable
      columns={columns}
      data={data}
      setData={setData}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      dropdownData={memoizedDropdownData}
      subtotalColumns={subtotalColumns}
      customInputs={{ carbon: CustomInputComponent }}
      hiddenColumns={hiddenColumns}
      toggleColumnVisibility={toggleColumnVisibility}
      disableRules={disableRules}
      dynamicPlaceholders={dynamicPlaceholders}
    />
  );
};

export default NonFuelVehicleTable;
